export const YA_REDIRECT_PAGE = "yandex_auth.html";
export const VK_REDIRECT_PAGE = "vk_auth.html";
